import { render, staticRenderFns } from "./max_calendar.vue?vue&type=template&id=b8c93c44&scoped=true"
import script from "./max_calendar.vue?vue&type=script&lang=js"
export * from "./max_calendar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8c93c44",
  null
  
)

export default component.exports